import { Component } from '@ecs/Component';

export class PointDefense implements Component {
  readonly type = 'PointDefense';

  constructor(
    public range: number = 100, // Reduced detection range
    public burstCooldown: number = 2000, // Longer time between bursts
    public bulletCooldown: number = 80, // Slower fire rate in burst
    public bulletsPerBurst: number = 5, // Fewer bullets per burst
    public lastBurstStart: number = 0,
    public bulletsFiredinBurst: number = 0,
    public lastBulletTime: number = 0,
    public bulletSpeed: number = 8, // Slower bullets
    public bulletSpread: number = 0.5, // More spread (less accurate)
    public bulletColor: string = '#ffaa00', // Orange tracer color
    public energyCost: number = 1, // Higher energy cost per bullet
    public damage: number = 1 // Damage per bullet
  ) {}
}